import { normalizeMethod } from './normalizeMethod';
import { RequestMethod } from '../types';

export function hasMethod(methods: RequestMethod[], method?: RequestMethod) {
    if (!method) {
        return false;
    }

    return methods.some(item => normalizeMethod(item) === normalizeMethod(method));
}
